export default "__VITE_ASSET__IZajShr___"